import Card from "@mui/material/Card";

interface Props {
  header: string;
  description: string;
  src: any;
  footerText: number;
  color: any;
  plusMin: any;
  type: string;
  reference_type: string;
  is_points_updated: boolean;
}

function TranscationCard({
  header,
  description,
  src,
  footerText,
  color,
  plusMin,
  type,
  reference_type,
  is_points_updated,
}: Props) {
  return (
    <Card
      className="relative flex flex-col bg-plainGreen cursor-pointer border-none shadow-none mb-2 w-full p-4"
      style={{ width: "100%" }}
    >
      {/* First row: Image and Header */}
      <div className="flex justify-between items-center">
        {/* Left Column: Image and Header Text */}
        <div className="flex items-center flex-1">
          {/* <img src={src} alt="Promotion icon" className="w-6 h-6" /> */}
          <span className="font-bold text-sm opacity-75 pl-2">{header}</span>
        </div>

        {/* Right Column: Reduced Width */}
        <div className="flex items-center w-1/4 justify-end">
          {type === "earned" &&
            reference_type === "order" &&
            !is_points_updated && (
              // <div className="absolute top-0 right-0 w-0 h-0 border-b-[30px] border-b-transparent border-l-[30px] border-l-red-500 transform rotate-90">

              <span className="inline-block bg-yellow-500 text-white text-[10px] w-[55px] px-2 py-[2px] rounded-full mb-2">
                On hold
              </span>
            )}
        </div>
      </div>

      {/* Second row: Description and footer text */}
      <div className="flex flex-row justify-between items-center mt-2">
        <div>
          <span className="text-xs opacity-75 ml-2">{description}</span>
        </div>
        <div className="flex justify-start">
          <span className="text-xs opacity-75" style={{ color: color }}>
            {plusMin}
            {footerText} Points
          </span>
        </div>
      </div>
    </Card>
  );
}

export default TranscationCard;
